import React, { useMemo } from 'react'
import { PREFERENCES } from '../../user/constants'

import {
  useIncidentsFetch,
  usePalmettoIncidentsFetch,
  useEventTypesFetch,
} from '../../palmetto/hooks'
import { useUserPreferencesFetch, useUserPreference } from '../../user/hooks'
import { useCrimeCategoriesFetch } from '../../crimeCategories/hooks'

import BaseLayout from '../../common/components/BaseLayout'

import Tab from '../../tabs/components/Tab'
import TabMenu from '../../tabs/components/TabMenu'
import TabPanel from '../../tabs/components/TabPanel'
import TabPanelContainer from '../../tabs/components/TabPanelContainer'

import IncidentPanel from '../../palmetto/components/IncidentPanel'
import PalmettoIncidentLayer from '../../map/components/PalmettoIncidentLayer'
import UserPanel from '../../user/components/UserPanel'

import Map from '../../map/components/Map'
import Zoom from '../../map/components/Zoom'
import BasemapToggle from '../../map/components/BasemapToggle'
import Compass from '../../map/components/Compass'

import styles from './MainLayout.module.css'

const MainLayout = () => {
  useIncidentsFetch() // Run the incident fetch loop
  useCrimeCategoriesFetch() // fetch the list of crime categories
  usePalmettoIncidentsFetch() // fetch incidents from palmetto system
  useEventTypesFetch() // fetch event types
  useUserPreferencesFetch() // fetch user's preferences

  const basemap = useUserPreference(PREFERENCES.DEFAULT_BASEMAP) || 'streets-vector'

  const mapPadding = useMemo(
    () => ({
      top: 60,
      left: 460,
      right: 10,
      bottom: 20,
    }),
    []
  )

  return (
    <BaseLayout title="Palmetto Incidents">
      <div className={styles.tabBar}>
        <TabMenu>
          <Tab path="/palmetto/userMenu" icon="fa fa-user" />
          <Tab
            path="/palmetto/incidentList"
            defaultPath="/palmetto"
            icon="fa fa-list-ul"
          />
        </TabMenu>
      </div>
      <div className={styles.sideBar}>
        <TabPanelContainer>
          <TabPanel path="/palmetto/userMenu">
            <UserPanel />
          </TabPanel>
          <TabPanel path="/palmetto/incidentList">
            <IncidentPanel />
          </TabPanel>
          <TabPanel>
            <IncidentPanel />
          </TabPanel>
        </TabPanelContainer>
      </div>
      <Map basemap={basemap} padding={mapPadding}>
        <BasemapToggle
          position="top-right"
          next={basemap === 'streets-vector' ? 'satellite' : 'streets-vector'}
        />
        <Compass position="bottom-right" />
        <Zoom position="bottom-right" />
        <PalmettoIncidentLayer />
      </Map>
    </BaseLayout>
  )
}

export default MainLayout
